module.exports = __webpack_public_path__ + "static/img/10-1.bfd372c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/10-1.jpg
// module id = cXjj
// module chunks = 0